import Reveal from "./Reveal";

const STEPS = [
  "garante tua vaga por R$27,90",
  "recebe acesso ao app e ao grupo",
  "segunda, dia 27/07, todo mundo começa junto",
  "21 dias marcando check-in dos 4 hábitos",
  "top 5 mais consistentes levam prêmio",
  "quem participou destrava a oferta fundadora da escape club",
];

const HowItWorks = () => (
  <section className="px-6 py-20 sm:py-28">
    <div className="mx-auto max-w-xl">
      <Reveal>
        <h2 className="text-center text-3xl font-extrabold tracking-[-0.03em] sm:text-5xl">
          como funciona
        </h2>
      </Reveal>
      {/* timeline vertical: linha contínua atrás dos números */}
      <ol className="relative mt-12">
        <div
          className="absolute bottom-5 left-[17px] top-2 w-px bg-black/10"
          aria-hidden="true"
        />
        {STEPS.map((step, i) => (
          <Reveal key={step} delay={i * 90}>
            <li className="group relative flex items-start gap-5 pb-9 last:pb-0">
              <span className="z-10 flex h-9 w-9 flex-none items-center justify-center rounded-full border border-black bg-white font-mono text-sm transition-colors duration-300 group-hover:bg-black group-hover:text-white">
                {i + 1}
              </span>
              <span className="pt-1.5 text-base font-medium leading-snug sm:text-lg">
                {step}
              </span>
            </li>
          </Reveal>
        ))}
      </ol>
    </div>
  </section>
);

export default HowItWorks;
